import api from "../api";


export const getSnmpTargets = async (mac) => {
  try {
    const response = await api.get(`mivulite/snmp/device/${mac}/targets`);
    return response.data;
  } catch (error) {
    console.error("Error fetching snmps:", error);
    throw error;
  }
};


export const getSnmpTargetByMac = async (mac) => {
  try {
    const response = await api.get(`mivulite/devices/mac/${mac}/config`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching config for device ${mac}:`, error);
    throw error;
  }
};


export const createSnmpTarget = async () => {
  try {
    const response = await api.post("mivulite/snmp/targets");
    return response.data;
  } catch (error) {
    console.error("Error fetching devices:", error);
    throw error;
  }
};


export const updateSnmpTarget = async (id, config) => {
  try {
    const response = await api.put(`mivulite/snmp/targets/${id}`, config);
    return response.data;
  } catch (error) {
    console.error("Error fetching snmps:", error);
    throw error;
  }
};


export const deleteSnmpTarget = async (id) => {
  try {
    const response = await api.delete(`mivulite/snmp/targets/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching devices:", error);
    throw error;
  }
};